import { fetchCurrentUser, logoutUser, getStoredUser, clearToken } from '../../lib/auth.js';
import { getLoginPath, getLogoutPath } from '../../auth-landing.js';
import { els, setStatus } from './dom.js';

function renderUserName(user) {
  const target = els.userName();
  if (!target) return;
  target.textContent = user?.username || user?.email || user?.name || '已登录用户';
}

export function bindUserDropdown() {
  const dropdown = els.userDropdown();
  const trigger = els.userName();
  const logoutBtn = els.logoutBtn();
  if (!dropdown || !trigger) return;
  trigger.addEventListener('click', (ev) => {
    ev.stopPropagation();
    dropdown.classList.toggle('open');
  });
  document.addEventListener('click', (ev) => {
    if (!dropdown.contains(ev.target)) dropdown.classList.remove('open');
  });
  logoutBtn?.addEventListener('click', async () => {
    await logoutUser();
    window.location.href = getLogoutPath();
  });
}

export async function ensureAuthOrRedirect() {
  const cached = getStoredUser();
  if (cached) renderUserName(cached);
  try {
    const me = await fetchCurrentUser();
    renderUserName(me?.user || me);
    return true;
  } catch (err) {
    if (err?.status === 401) {
      clearToken();
      window.location.href = getLoginPath();
      return false;
    }
    setStatus('无法获取用户信息，请稍后重试', 'error');
    return true;
  }
}
